import React from "react";
import Slider from "react-slick";
import { bannerimage } from "../Constant/Index";
import { Link } from "react-router-dom";

function Bannerslider() {
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="slider-dv">
        <div className="container">
          <div className="slider-container">
            <Slider {...settings}>
              <div className="slide-img">
                <div className="slide-span">
                  <span className="span-all">Powerfulhand</span>
                </div>
                <img src={bannerimage} className="img-fluid" />
                <div className="slider-text">
                  <h2 className="primary-color">
                    Elevate Your Space with Incense Candles!
                  </h2>
                </div>

                <div className="slider-para">
                  <p>
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium.
                  </p>
                </div>
                <div className="slide-btn">
                <Link to="/shop">
                    <button className="btn-all">shop now</button>
                  </Link>
                </div>
              </div>
              <div className="slide-img">
                <div className="slide-span">
                  <span className="span-all">Powerfulhand</span>
                </div>
                <img src={bannerimage} className="img-fluid" />
                <div className="slider-text">
                  <h2 className="primary-color">
                    Elevate Your Space with Incense Candles!
                  </h2>
                </div>
                <div className="slider-para">
                  <p>
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium.
                  </p>
                </div>
                <div className="slide-btn">
                  <Link to="/shop">
                    <button className="btn-all">shop now</button>
                  </Link>
                </div>
              </div>
              <div className="slide-img">
                <div className="slide-span">
                  <span className="span-all">Powerfulhand</span>
                </div>
                <img src={bannerimage} className="img-fluid" />
                <div className="slider-text">
                  <h2 className="primary-color">
                    Elevate Your Space with Incense Candles!
                  </h2>
                </div>
                <div className="slider-para">
                  <p>
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accusantium doloremque laudantium.
                  </p>
                </div>
                <div className="slide-btn">
                <Link to="/shop">
                    <button className="btn-all">shop now</button>
                  </Link>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
}

export default Bannerslider;
